<template>
  <div class="app">
    <h1>关于我们</h1>
    <Header :activeIndex="'1-1'"/>

    <div class="margintop">
      <div class="tiaozhuan"><span style="cursor: pointer;" @click="pathIndex">首页</span><span>&nbsp;&gt;&gt;&nbsp;</span><span>关于我们</span></div>
      <div class="biaoti">公司介绍：</div>
      <div class="jianjie">
        名企科技是工商局、财政局批复的财税服务平台。公司成立于2017年2月，位于北京市核心区-西城区。公司主要业务有：工商注册、代理记账、工商变更、股权变更、注销清算、申请许可证、申请资质、商标代办、高新企业代理申报、社保服务托管、网站建设等服务。
      </div>
      <div class="juzhong">
        <div class="fuwu01">
          <div class="fuwu02">
            <div class="fuwu03">注册<br>公司</div>
            <div class="fuwu04">不续费<br>地址
            </div>
            <div class="fuwu04">代理<br>记账</div>
            <div class="fuwu04">社保<br>托管</div>
            <div class="fuwu04">刻章<br>补照</div>
          </div>
          <div class="fuwu05">
            <div class="fuwu06">变更<br>注销</div>
            <div class="fuwu07">审计<br>咨询</div>
            <div class="fuwu07">资质<br>许可</div>
            <div class="fuwu07">商标<br>软著</div>
            <div class="fuwu07">税务<br>筹划</div>
          </div>

        </div>
      </div>
      <div class="biaoti1">全国服务：</div>
      <div class="jianjie">
        名企科技的的业务范围已经覆盖：北京市朝阳区，海淀区、西城区、东城区、丰台区、石景山区、怀柔区、密云区、房山区、门头沟区、延庆区、平谷区、经济开发区、大兴区、通州区等北京各个区域，以及上海、广州、深圳、内蒙古、湖北、江西、天津、重庆、河南等全国多个省市。
      </div>
      <div class="juzhong">
        <img class="huanhang1" :src="require('../assets/img/mapofChina.jpg')"
          alt="名企科技业务范围已经覆盖：北京市朝阳区，海淀区、西城区、东城区、丰台区、石景山区、怀柔区、密云区、房山区、门头沟区、延庆区、平谷区、经济开发区、大兴区、通州区等北京各个区域，以及上海、广州、深圳、内蒙古、湖北、江西、天津、重庆、河南等全国多个省市">
      </div>
      <div class="biaoti1">服务的公司：</div>
      <div class="juzhong">
        <div class="kehu">
          <div>
            <div class="dazi">
              小型企业
            </div>
            <div class="zuoer">
              <ul style="list-style-type: none;">
                <li>♢ 初创公司</li>
                <li>♢ 小微企业</li>
              </ul>
            </div>
          </div>
          <div class="youyi">
            <ul>
              <li>注册执照、刻章</li>
              <li>代理记账、报税</li>
              <li>发票、社保托管</li>
            </ul>
          </div>
        </div>
        <div class="kehu1">
          <div>
            <div class="dazi">
              中型公司
            </div>
            <div class="zuoer">
              <ul style="list-style-type: none;">
                <li>♢ A、B轮公司</li>
                <li>♢ 事业单位</li>
              </ul>
            </div>
          </div>
          <div class="youyi">
            <ul>
              <li>记账报税</li>
              <li>财务梳理、优化</li>
              <li>办理资质、许可</li>
            </ul>
          </div>
        </div>
        <div class="kehu1">
          <div>
            <div class="dazi">
              大型公司
            </div>
            <div class="zuoer">
              <ul style="list-style-type: none;">
                <li>♢ 上市公司</li>
                <li>♢ 国有企业</li>
              </ul>
            </div>
          </div>
          <div class="youyi">
            <ul>
              <li>工商、税务服务</li>
              <li>办理资质、许可</li>
              <li>财务梳理、优化</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <Youshi />
    <Footer />
  </div>
</template>


<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Youshi from '@/components/Youshi.vue'

export default {
  name: 'about',
  components: {
    Header,
    Footer,
    Youshi
  },
  data() {
    return {
      imgCount: 0,
      currentIndex: 0,
      intervalID: '',
      // showData: true,
      pppclose: true,
      row1: ['注册<br>公司', '不续费<br>地址', '代理<br>记账', '社保<br>托管', '刻章<br>补照'],
      row2: ['变更<br>注销', '审计<br>咨询', '资质<br>许可', '商标<br>软著', '税务<br>筹划']
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    // console.log(this.$root.showData.showData);
    this.$root.showData.showData = false;
  },
  methods: {
    formatText(text) {
      return text;
    },
    pppopco() {
      this.$root.ppp.ppp = !this.$root.ppp.ppp
    },
    pathIndex() {
      this.$router.push('/');
    },
    pathRemen() {
      this.$router.push('/remen');
    },
    pathJizhang() {
      this.$router.push('/jizhang')
    },
    pathgongshang() {
      this.$router.push('/gongshang')
    },
    pathshuiwu() {
      this.$router.push('/shuiwu');
    },
    pathzhichan() {
      this.$router.push('/zhichan')
    },
    pathxuke() {
      this.$router.push('/xuke')
    },
    pathrenshi() {
      this.$router.push('/renshi')
    },
    pathxueyuan() {
      this.$router.push('/xueyuan');
    },
    pathcontact() {
      this.$router.push('/contact')
    },
    pathabout() {
      this.$router.push('/about')
    },
  }
}
</script>

<style>
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.el-carousel__button {
  background-color: #000 !important;
}

.el-menu-item.is-active {
  background-color: #b30101 !important;
}

.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 45px !important;
  line-height: 45px !important;
  margin: 0;
}

@media (max-width: 768px) {
  .responsive-carousel el-carousel el-carousel--horizontal {
    height: 128px !important;
  }

  .el-carousel__indicators el-carousel__indicators--horizontal {
    margin-top: 15px !important
  }

  .el-pager li {
    padding: 0 0px !important;
    min-width: 25.5px !important;
  }

  .el-menu--horizontal>.el-menu-item {
    float: left;
    height: 30px !important;
    line-height: 30px !important;
    margin: 0;
  }
}
</style>

<style scoped>
/* 我们的客户 */
.kehu:hover .dazi,
.kehu:hover .zuoer,
.kehu:hover .youyi,
.kehu1:hover .dazi,
.kehu1:hover .zuoer,
.kehu1:hover .youyi {
  border-color: #c9c9c9;
}

/* 保持其他已有样式 */
.kehu,
.kehu1 {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.kehu1 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 40px;
}

.dazi {
  height: 67px;
  width: 130px;
  border: 6px solid #d22525;
  font-size: 25px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 10px;
}

.zuoer {
  height: 69px;
  width: 130px;
  border-left: 6px solid #d22525;
  border-right: 6px solid #d22525;
  border-bottom: 6px solid #d22525;
  font-size: 18px;
  margin-top: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-left-radius: 10px;
  flex-direction: column;
  text-align: left;
}

.youyi {
  height: 142px;
  width: 153px;
  border-top: 6px solid #d22525;
  border-right: 6px solid #d22525;
  border-bottom: 6px solid #d22525;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  flex-direction: column;
  text-align: left;
}


.fangkuai {
  list-style-type: square;
  margin-top: 0px;
  padding-left: 10px;
}

.yuanquan {
  list-style-type: circle;
}

ul,
li {
  margin: 0;
  padding: 0;

}


/* 其他 */
ul,
li {
  margin: 0;
  padding: 0;
}

h1 {
  font-size: 0%;
}

.biaoti {
  font-size: 20px;
  font-weight: 700;
}

.biaoti1 {
  font-size: 20px;
  font-weight: 700;
  margin-top: 15px;
}

.jianjie {
  margin-top: 10px;
  color: black;
  line-height: 32px;
  font-size: 16px;
}

.juzhong {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}

.fuwu01 {
  background-color: #ffc205;
  width: 574px;
  height: 196px;
  font-weight: 700;
  margin-top: 10px;
}

.fuwu02 {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: 11px;
}

.fuwu03 {
  width: 85px;
  height: 79px;
  background-color: #fdff05;
  color: #4675c5;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.fuwu04 {
  width: 85px;
  height: 79px;
  margin-left: 20px;
  background-color: #fdff05;
  color: #4675c5;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.fuwu05 {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: 16px;
}

.fuwu06 {
  width: 85px;
  height: 79px;
  background-color: #4675c5;
  color: #fdff05;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.fuwu07 {
  width: 85px;
  height: 79px;
  margin-left: 20px;
  background-color: #4675c5;
  color: #fdff05;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.huanhang {
  margin-top: 10px;
  width: 574px;
  height: 196px;
  display: flex;
}

.huanhang1 {
  margin-top: 10px;
  width: 590px;
  height: 378px;
  display: flex;
}

.margintop {
  text-align: left;
  margin-left: 25%;
  margin-right: 25%;
  font-size: 25px;
  margin-top: 118px;
  font-weight: 500;
}

.tiaozhuan {
  text-align: left;
  margin-bottom: 0.83em;
  font-size: 18px;
  font-weight: 500;
}

@media (max-width: 768px) {
  /* 图片 */
  .biaoti {
    font-size: 15px;
    font-weight: 700;
  }

  .biaoti1 {
    font-size: 15px;
    font-weight: 700;
    margin-top: 8px;
  }

  .jianjie {
    margin-top: 5px;
    color: black;
    line-height: normal;
    font-size: 13px;
  }

  .fuwu01 {
    background-color: #ffc205;
    width: 348px;
    height: 146px;
    font-weight: 700;
    margin-top: 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .fuwu02 {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-top: 0px;
    font-size: 16px;
  }

  .fuwu03 {
    width: 52px;
    height: 52px;
    background-color: #fdff05;
    color: #4675c5;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .fuwu04 {
    width: 52px;
    height: 52px;
    margin-left: 11px;
    background-color: #fdff05;
    color: #4675c5;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .fuwu05 {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-top: 14px;
  }

  .fuwu06 {
    width: 52px;
    height: 52px;
    background-color: #4675c5;
    color: #fdff05;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .fuwu07 {
    width: 52px;
    height: 52px;
    margin-left: 11px;
    background-color: #4675c5;
    color: #fdff05;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .huanhang1 {
    margin-top: 0px;
    width: 295px;
    height: 189px;
    display: flex;
  }

  /* 我们的客户 */
  .juzhong {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 5px;
  }

  .kehu {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .kehu1 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0px;
    margin-top: 8px;
  }

  .dazi {
    height: 46px;
    width: 80px;
    border: 1px solid black;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 10px;
  }

  .zuoer {
    height: 46px;
    width: 80px;
    border-left: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
    font-size: 10px;
    margin-top: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom-left-radius: 10px;
    flex-direction: column;
    text-align: left;
  }

  .fangkuai {
    list-style-type: square;
    margin-top: 0px;
    padding-left: 10px;
  }

  .youyi {
    height: 93px;
    width: 106px;
    border-top: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    flex-direction: column;
    text-align: left;
  }

  .yuanquan {
    list-style-type: circle;
  }

  
  /* 其他 */
  .margintop {
    margin-top: 100px;
    text-align: left;
    margin-left: auto;
    margin-right: auto;
    font-size: 15px;
    margin-left: 2%;
    margin-right: 2%;
    margin-bottom:5px;
  }

  .tiaozhuan {
    text-align: left;
    margin-bottom: 0.83em;
    font-size:11px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/about.vue